import { InvoiceStatus } from '@link/agent/services/const';

export default {
  common: {
    search: '搜索',
    keyword: '关键词',
    cancelAll: '批量取消',
    complete: '完成'
  },
  layouts: {
    sidebar: {
      notifications: '通知',
      contractsList: '合同管理',
      agents: '旅行社管理',
      booking: '预订',
      settings: '设置',
      changePassword: '更改密码',
      finance: '付款管理',
      bulkOrder: '批量预订',
      activityList: '在售商品一览'
    }
  },
  views: {
    activityList: {
      pageTitle: '在售商品一览',
      searchTitle: '商品检索',
      activityId: '商品ID',
      activityUrl: '商品URL',
      title: '商品名',
      supplier: '供应商',
      supplierId: '供应商ID',
      supplierName: '供应商名',
      category: '类别',
      country: '商品国家・地区',
      confirmationType: '库存类型',
      inSalePeriod: '销售期间内',
      unspecified: '不指定',
      salePeriod: '销售期间',
      netPrice: '批发价',
      grossPrice: '销售价（GROSS）',
      unlimited: '无期限',
      downloadCsv: '下载CSV',
      snapshotHint:
        '显示的数据为前一天的数据（每日深夜更新）。最后更新时间：{{time}}'
    },
    bulkBookingDetail: {
      history: '操作内容',
      action: '操作',
      operator: '操作者',
      date: '日期',
      message: '消息',
      notifyPayment: '汇款通知',
      paymentDate: '汇款日',
      paymentConfirmed: '已确认汇款',
      infoSentToSupplier: '已将信息发送至供应商'
    },
    bulkBookingForm: {
      operator: '操作者',
      paymentDate: '预计汇款日期',
      message: '消息',
      agentReservationNo: '旅行社预订编号（备注）',
      agentReservationNote: '旅行社预订须知'
    },
    addPrepayment: {
      agentId: '旅行社 ID',
      agentName: '旅行社名称',
      address: '公司地址',
      date: '付款期限',
      currency: '货币',
      amount: '付款金额',
      note: '请将预付账单通过邮件发送至 LINKTIVITY 业务负责人。',
      submit: '创建预付账单',
      reset: '重置'
    },
    financeHistory: {
      title: '付款记录',
      dataAggregation: '数据汇总',
      aggregationUnit: '汇总单位',
      targetPeriod: '时间范围',
      monthly: '月度',
      weekly: '双周',
      confirmed: '已确定',
      canceledRefund: '取消退款',
      differenceAdjusted: '差额已调整',
      totalAmount: '合计金额',
      cancellationFee: '（含取消费用）',
      totalPaymentAmount: '付款金额合计',
      price: '({{currency}})',
      salesPrice: '销售价格',
      wholesalePrice: '批发价格',
      commission: '手续费',
      transactionSearch: '交易查询',
      applicationDate: '申请日',
      participationDate: '参加日',
      transactionStatus: '交易状态',
      keyword: '关键词',
      activity: '商品',
      plan: '方案',
      supplier: '供应商',
      reservationNumber: '预订编号',
      currency: '货币'
    },
    financeTransactions: {
      title: '结算报表',
      transactionStatus: '结算状态',
      difference: '差异调整',
      dueDate: '账单开具日期',
      invoiceNumber: '账单ID',
      date: '请款周期',
      fromDate: '{{fromDate}}～{{toDate}}',
      currency: '货币单位',
      amount: '付款金额合计',
      adjustedAmount: '调整金额',
      finalAmount: '最终合计金额',
      adjust: '调整',
      showjust: '显示',
      change: '已付款',
      invoice: '账单明细',
      jaInvoice: '支付通知书(日文)',
      jaInvoiceDetails: '明细书(日文)',
      enInvoice: '支付通知书(英文)',
      enInvoiceDetails: '明细书(英文)',
      attachment: '附件',
      changeTitle: '是否已付款？',
      changeMessage: '交易状态将变更为“已付款”'
    },
    financeAccount: {
      title: '余额管理',
      listTitle: '充值记录',
      accountBalance: '账户余额',
      accountBuffer: '账户缓冲金',
      deposit: '进行充值',
      generatePrepaidInvoice: '创建预付账单',
      billingCycle: '结算周期',
      paymentMethod: '付款方式',
      currency: '货币',
      contractNote: '以上设置基于合同内容。',
      contactSupport: '如需变更，请联系 LINKTIVITY 负责人。',
      date: '日期时间',
      amount: '金额',
      prepaidInvoice: '预付账单',
      transactionStatus: '状态',
      remark: '备注',
      accountBalanceAmount: '账户前余额',
      accountBalanceAfterAmount: '充值后余额',
      accountBufferAmount: '账户缓冲金',
      verificationCode: '确认码',
      enterDepositAmount: '请输入充值金额',
      depositAmount: '充值金额',
      proceedToPayment: '前往支付流程',
      chargeCompleted: '汇款完成',
      cancel: '取消',
      confirmChargeCompleted: '将向 LINKTIVITY 通知汇款完成。',
      changeStatusToCharged: '将状态变更为"汇款完成"。',
      change: '操作',
      confirmCancel: '是否取消？',
      changeStatusToCancelled: '将状态变更为"已取消"。',
      insufficientBalanceNotification: '设置余额不足通知',
      notificationDialogTitle: '余额不足通知设置',
      notificationDialogSubtitle: '当余额低于指定金额时，将通过邮件通知您。',
      notificationReceiveLabel: '接收通知',
      notificationEnabled: '接收',
      notificationDisabled: '不接收',
      notificationThresholdLabel: '指定金额',
      notificationSave: '保存设置'
    },
    dashboard: {
      title: '数据看板'
    },
    searchActivities: {
      title: '新预订',
      filter: {
        lang: '翻译语言',
        otaId: '旅行社',
        supplierId: '供应商',
        categories: '分类',
        country: '出发地',
        activityTitle: '商品名称'
      },
      plan: '方案',
      openBookingForm: '打开预订表单',
      viewDetail: '查看详情',
      total: '搜索结果：{{total}}条',
      location: '{{country}}',
      city: '・{{city}}',
      supplier: '{{name}}({{id}})'
    },
    activityDetail: {
      plan: '选择方案',
      plans: {
        stockAndPrice: '库存与价格',
        calendar: '库存日历',
        priceCalendar: '价格日历',
        quantity: '库存数量',
        currentPrice: '当日价格',
        noDateSelected: '请选择日期',
        unit: '单位',
        displayPrice: '销售价格',
        netPrice: '批发价格',
        otherDate: '其他适用日期',
        priceTable: '价格表',
        priceGroup: '价格组',
        applicablePeriod: '适用期间',
        cannotBeBookIndependently: '不可单独购买',
        commission: '手续费'
      }
    },
    bookingForm: {
      title: '预订表单',
      steps: {
        step1: '基本信息',
        step2: '预订时必要信息',
        step3: '预订申请'
      },
      prev: '上一步',
      next: '下一步',
      form: {
        plans: '方案',
        targetDate: '参加日',
        time: '开始时间',
        amount: '人数',
        amountDesc: '预订数量限制：{{capacity}}',
        amountDescBulk:
          '预订数量限制：{{capacity}}；每次预订每个单位最多 999 张。',
        accountBalance: '账户余额',
        availableAmount: '可用金额',
        checkPrice: '确认余位与价格',
        checkList: '参加限制',
        checkListTip: '请于预订前确认',
        operator: '操作员',
        paymentDate: '预计汇款日期',
        message: '消息',
        requiredInfo: '必要信息',
        requiredInfoPerParticipant: '必要信息（每位参加者）',
        allotmentQuantity: '数量 {{quantity}}',
        paymentCurrency: '付款金额（销售价格）',
        totalPriceForBooking: '当地货币总金额',
        paymentCurrencyExchange: '汇率',
        unit: '单位',
        representative: '参加者代表',
        pleaseSelectUnit: '请选择单位',
        displayPrice: '销售价格',
        netPrice: '批发价格'
      },
      bookingConfirmation: {
        title: '您的预订已被受理',
        message: '申请已完成，信息已发送至供应商·',
        reservationNumber: '预订编号',
        print: '打印用',
        display: '显示用'
      },
      participantInfo: {
        firstName: '代表人（名）',
        lastName: '代表人（姓）',
        agentReservationNo: '旅行社预订编号（备注）',
        agentReservationNote: '旅行社预订特别事项'
      },

      bookingFields: {
        participantEmailAddress: '参加者邮箱',
        hotelName: '住宿名称',
        hotelAddress: '住宿地址',
        hotelReservationLastName: '住宿代表人姓名（姓）',
        hotelReservationFirstName: '住宿代表人姓名（名）',
        hotelReservationName: '住宿代表人姓名',
        hotelTel: '住宿电话号码',
        arrivalDate: '当地抵达日',
        arrivalTime: '抵达时间',
        arrivalFlightNumber: '航班到达班次',
        departureDate: '出发日',
        departureTime: '出发时间',
        departureFlightNumber: '航班出发班次',
        destinationEmail: '当地联系方式（邮箱）',
        destinationTel: '当地联系方式（电话号码）',
        gender: '性别',
        agentChannelRegion: '旅行社所在国家・地区',
        agentChannelLanguage: '旅行社使用语言',
        participantResidentRegion: '参加者居住国家/地区',
        participantLanguage: '参加者使用语言',
        passengersQuantity: '乘车人数',
        prescriptionMaskQuantityFree: '是否需要带度数面镜 ※免费',
        prescriptionMaskQuantityPaid: '是否需要带度数面镜 ※现场支付',
        preferredStartTime: '希望开始时间',
        preferredPickUpLocation: '接送／上车地点',
        preferredDropOffLocation: '送达／下车地点',
        participantsQuantity: '参加人数',
        luggageQuantity: '行李箱数量（合计）',
        childrenWithoutSeatQuantity: '不占座婴幼儿',
        childSeatQuantityPaid: '是否使用儿童座椅 ※现场支付',
        childSeatQuantityFree: '是否使用儿童座椅 ※免费',
        guideJa: '希望日语导览',
        driverJa: '希望日语司机',
        guideEn: '希望英文导览',
        driverEn: '希望英文司机',
        guideZh: '希望中文导览',
        driverZh: '希望中文司机',
        guideKo: '希望韩文导览',
        driverKo: '希望对应韩文司机',
        preferredGuideLanguageCode: '希望导览语言',
        preferredDriverLanguageCode: '希望司机语言',
        passportNationality: '国籍',
        passportFirstName: '参加者名字（护照拼音）',
        passportLastName: '参加者姓氏（护照拼音）',
        dateOfBirth: '出生日期',
        age: '年龄',
        passportNumber: '护照号码',
        eyesight: '视力',
        weightKg: '体重（kg）',
        heightCm: '身高（cm）',
        shoeSizeCm: '鞋码（cm）',
        weightLbs: '体重（lbs）',
        heightIn: '身高（ft/in）',
        clothesSize: '服装尺寸',
        vegetarianMeals: '是否需要素食',
        divingExperienceTimes: '潜水经验次数',
        rentalEquipmentsFree: '是否需要器材租赁 ※免费',
        rentalEquipmentsPayLocally: '是否需要器材租赁 ※现场支付',
        male: '男性',
        female: '女性',
        other: '其他',
        yes: '是',
        no: '否'
      },

      alert: {
        warning: '所选日期的可用库存少于所需人数，请更改日期或人数。',
        info: '同意取消政策并提交申请',
        cannotBookAlone: '所选票券不可单独购买。'
      }
    },
    reservations: {
      title: '未确定的预订'
    },
    agentDetail: {
      title: '旅行社信息'
    },
    orgList: {
      title: '群组管理'
    },
    agentAccountList: {
      title: '账户管理'
    },
    bookReservations: {
      paymentAppliedDate: '付款申请日期',
      id: 'ID',
      productPlan: '商品/套餐',
      expirationDate: '有效期',
      participationDate: '参加日期（当地商品）',
      holdReservation: '未确定的预订',
      count: '条'
    }
  },
  const: {
    allotmentStatus: {
      plenty: '有库存',
      insufficient: '库存紧张',
      empty: '无库存',
      unavailable: '不可销售'
    },
    bookingStatus: {
      yes: '可预订',
      no: '不可预订'
    },
    activityTags: {
      NON_CANCELLABLE: '不可取消',
      FREE_CANCEL_BEFORE_ISSUE_TICKET: '兑换前可免费取消',
      ADVANCE_CANCELLATION_POLICY: '特殊取消政策',
      INSTANT_BOOK: '立即预订',
      NON_QR_CODE: '人工验证凭证',
      QR_CODE: 'QR凭证',
      ETICKET: '电子验票票券（需手机）'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '未付款',
      [InvoiceStatus.InvoiceStatusConfirmed]: '付款完成',
      [InvoiceStatus.InvoiceStatusPaid]: '待入账确认',
      [InvoiceStatus.InvoiceStatusCancelled]: '已取消'
    }
  }
};
